




import { Component, Vue } from "vue-property-decorator";
import { store } from "@/store";
import { readHasAdminAccess } from "@/store/main/getters";

const routeGuardAdmin = async (to: any, from: any, next: any) => {
  if (!readHasAdminAccess(store)) {
    next("/main");
  } else {
    next();
  }
};

@Component
export default class Admin extends Vue {
  public beforeRouteEnter(to: any, from: any, next: any) {
    routeGuardAdmin(to, from, next);
  }

  public beforeRouteUpdate(to: any, from: any, next: any) {
    routeGuardAdmin(to, from, next);
  }
}
